import { EventEmitter, Injectable } from '@angular/core';
import { EXRateType } from "libraries/interfaces/ITotal";

@Injectable({
    providedIn: 'root'
})
export class PriceSwitcherService {
    public selectedPrice: EXRateType;
    public hasPriceSwitcher: boolean;
    public hasPriceSwitcherPermission: boolean;

    public readonly selectPriceEvent: EventEmitter<EXRateType> = new EventEmitter();
    public readonly hasPriceSwitcherEvent: EventEmitter<boolean> = new EventEmitter();

    public selectPrice(priceType: EXRateType): void {
        this.selectPriceEvent.emit(priceType);
        this.selectedPrice = priceType;
    }
    public showPriceSwitcher(isShow: boolean): void {
        this.hasPriceSwitcherEvent.emit(isShow);
        this.hasPriceSwitcher = isShow;
    }
}
